import { useSelector } from 'react-redux';

import { ViewTypeName } from '@air/api/types';

import { useIsSearchActive } from '~/hooks/search/useIsSearchActive';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';
import { currentViewTypeNameSelector } from '~/store/configViews/selectors';

export type UseShowExpandNestedContentToggleParams = {
  isDisabled?: boolean;
};

export const useShowExpandNestedContentToggle = ({
  isDisabled = false,
}: UseShowExpandNestedContentToggleParams = {}) => {
  const { ui2026 } = useTemporaryFeatureFlags();
  const { isSearchActive } = useIsSearchActive();
  const currentViewTypeName = useSelector(currentViewTypeNameSelector);
  const isKanbanView = currentViewTypeName === ViewTypeName.kanban;

  return {
    showExpandNestedContentToggle: ui2026 && !isSearchActive && !isKanbanView && !isDisabled,
  };
};
